import { get } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, getFormValues } from 'redux-form';

import BasicSelect from '../../../../../shared/components/formComponents/groups/BasicSelect';
import BasicText from '../../../../../shared/components/formComponents/groups/BasicText';
import { VerbRichTextEditor } from '../../../../../shared/components/formComponents/VerbRichTextEditor';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../../../shared/components/VerbButton';
import RichTextNotesHeader from './RichTextNotesHeader';

import { RuntimeContext } from '../../../../../../common/RuntimeContext';
import { postTestEmail } from '../../../../../shared/actions/index';

const availableTemplates = [
    {
        _id: 'purple-rockets',
        title: 'Purple Rockets'
    },
    {
        _id: 'purple-triangles',
        title: 'Purple Triangles'
    },
    {
        _id: 'purple-stripes',
        title: 'Purple Stripes'
    },
    {
        _id: 'black-stripes',
        title: 'Black Stripes'
    },
    {
        _id: 'black-body',
        title: 'Black Body'
    }
];

class EmailSectionItem extends Component {
    static propTypes = {
        memberReference: PropTypes.string,
        postTestEmail: PropTypes.func.isRequired,
        submitting: PropTypes.bool.isRequired,
        currentValues: PropTypes.object
    };

    static contextType = RuntimeContext;

    /**
     * Private Methods
     */
    _getFormValue(property) {
        return get(this.props.currentValues, `${property}`, '');
    }

    sendTestEmail = () => {
        const { postTestEmail, memberReference } = this.props;

        const emailTemplateFieldName = memberReference
            ? `${memberReference}.content.emailTemplate`
            : 'content.emailTemplate';
        const ctaTextFieldName = memberReference ? `${memberReference}.content.ctaText` : 'content.ctaText';
        const subjectFieldName = memberReference ? `${memberReference}.content.subject` : 'content.subject';
        const bodyFieldName = memberReference ? `${memberReference}.content.body` : 'content.body';

        const params = {
            body: {
                testEmailAddress: this._getFormValue('testEmailAddress'),
                emailTemplate: this._getFormValue(emailTemplateFieldName),
                ctaText: this._getFormValue(ctaTextFieldName),
                subject: this._getFormValue(subjectFieldName),
                body: this._getFormValue(bodyFieldName)
            },
            pathsContext: this.context.pathsWeb
        };

        postTestEmail(params);
    };

    render() {
        const { memberReference, submitting = false } = this.props;

        return (
            <div className={'email-section-item'}>
                <div className={'row'}>
                    <Field
                        name={memberReference ? `${memberReference}.content.emailTemplate` : 'content.emailTemplate'}
                        label={'Email Template'}
                        className={'col-12 col-sm-4'}
                        options={availableTemplates}
                        component={BasicSelect}
                        valueKey={'_id'}
                        labelKey={'title'}
                    />
                    <Field
                        name={memberReference ? `${memberReference}.content.ctaText` : 'content.ctaText'}
                        label={'Call to Action Text'}
                        className={'col-12 col-sm-4'}
                        component={BasicText}
                    />
                </div>
                <br />
                <div className={'row'}>
                    <Field
                        name={memberReference ? `${memberReference}.content.subject` : 'content.subject'}
                        label={'Subject'}
                        className={'col-8'}
                        component={BasicText}
                    />
                    <div className={'col-8'}>
                        <Field
                            name={memberReference ? `${memberReference}.content.body` : 'content.body'}
                            label={'Body'}
                            rows={3}
                            placeholder={'Enter email body content'}
                            component={VerbRichTextEditor}
                        />
                    </div>
                </div>

                <div className={'row'}>
                    <h5 className={'col-12'}>SEND A TEST EMAIL</h5>
                    <Field
                        name={`testEmailAddress`}
                        label={'Email Address to Test'}
                        className={'col-4'}
                        component={BasicText}
                    />
                    <VerbButton
                        className={'test-email-btn'}
                        onClick={this.sendTestEmail}
                        disabled={submitting}
                        buttonType={VERB_BUTTON_TYPE.PRIMARY_DEFAULT}
                        fontAwesomeIcon={'fa-envelope'}
                    />
                </div>
                <RichTextNotesHeader isEmail={true} />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    currentValues: getFormValues('TrackV2')(state)
});

const mapDispatchToProps = (dispatch) => ({
    postTestEmail: (params) => dispatch(postTestEmail(params))
});

export const EmailSectionItemComponent = EmailSectionItem;
export default connect(mapStateToProps, mapDispatchToProps)(EmailSectionItem);
